import { pusher } from '@infl-ts/util-pusher';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
import * as t from 'io-ts';
var LensNotification = t.type({
  data: t.type({
    attributes: t.intersection([t.type({
      'action-type': t.string
    }), t.partial({
      state: t.string
    })])
  })
});
export var subscribe = function subscribe(notificationHandler) {
  return function (userId) {
    return pipe(pusher, TE.chainEitherK(function (lensPusher) {
      return E.tryCatch(function () {
        return lensPusher.subscribe("private-user-".concat(userId));
      }, function () {
        return Error('Could not subscribe to private user channel');
      });
    }), TE.chainEitherK(function (userChannel) {
      return E.tryCatch(function () {
        return userChannel.bind('notifications', notificationHandler);
      }, function () {
        return Error('Could not bind to notifications event');
      });
    }));
  };
};